import {
  AdvisorProfileImage as ProfileImage,
  AdvisorEditButton as EditButton,
  AdvisorInputIcon as InputIcon,
  HorizontalLine as Hr,
  AdvisorInputWrapper,
} from './AdvisorProfile.styles';

export { ProfileImage, EditButton, InputIcon, Hr, AdvisorInputWrapper };
